<template>
  <orderPage :type="'inbound'"></orderPage>
</template>

<script>
import orderPage from "../order-template/index.vue";
export default {
  name: "orderIn",
  components: {
    orderPage
  },
  methods: {},
  data() {
    return {};
  },
  mounted() {}
};
</script>

<style lang="scss" scoped></style>
